<div #modal class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button id='memberPreviewModalDialogClose' type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        <h4 class="modal-title" id="myModalLabel">{{ data ? data.title : '' }}</h4>
      </div>
      <div class="modal-body">
        <div class="member-modal-cont">
          <div>Proof of employment</div>
          <div>
            <div *ngIf="loading" class="loading-cont">
              <div class="loading-spinner"></div>
            </div>
            <div *ngIf="!loading">
              <ch-file-viewer
                *ngIf="fileType !== 'other'; else proofDownload"
                [src]="src"
                [filetype]="fileType"
              ></ch-file-viewer>
              <ng-template #proofDownload>
                <button
                  type="button"
                  (click)="downloadProof()"
                  class="btn btn-primary normal"
                  [disabled]="loading"
                >
                  Download
                </button>
              </ng-template>
            </div>
          </div>
        </div>
        <button type="button" class="btn btn-success" (click)="accept()">Approve</button>
        <form id='memberPreviewModalDialogForm' class="flabs-select-form" #form="ngForm">
          <select
            class="btn btn-info"
            [(ngModel)]="selectForm.selectValue"
            name="selectValue"
            #selectValue="ngModel"
            (change)="requestNewId($event.target.value)"
          >
            <option [value]="null" selected disabled hidden>Request New ID</option>
            <option *ngFor="let reason of reasons" [value]="reason.value">{{ reason.label }}</option>
          </select>
        </form>
        <button id='memberPreviewModalDialogReject' type="button" class="btn btn-danger" (click)="reject()">Reject</button>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/member-preview-modal-dialog/member-preview-modal-dialog.component.html